import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const StatCard = ({ title, value, change, changeType, icon, iconClass, suffix, onClick }) => {
  const isPositive = changeType === "positive";
  return (
    <div className="db-kpi-card" onClick={onClick}>
      <div className="db-kpi-inner">
        <div className="db-kpi-info">
          <span className="db-kpi-label">{title}</span>
          <div className="db-kpi-value">
            {value}
            {suffix && <span className="db-kpi-suffix">{suffix}</span>}
          </div>
          {change && (
            <div className={`db-kpi-trend ${isPositive ? "positive" : "negative"}`}>
              {isPositive ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
              <span className="db-kpi-trend-value">{change}</span>
              <span className="db-kpi-trend-label">vs last month</span>
            </div>
          )}
        </div>
        <div className={`db-kpi-icon ${iconClass || ""}`}>{icon}</div>
      </div>
    </div>
  );
};

export default StatCard;
